Ext.define('SA.view.PromptWindow', {
    alias: 'widget.prompt-window',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    baseCls: 'sa-prompt-window',
    cancelAction: 'destroy',
    closeAction: 'destroy',
    floating: true,
    includeCancelBtn: false,
    includeCloseBtn: true,
    includeFooter: true,
    includeHeader: true,
    includeOkBtn: false,
    modal: true,
    okAction: 'destroy',
    plugins: 'sa-viewport-constrained-auto-center',

    initComponent() {
        var me = this,
            cls = this.cls,
            castArray = Ext.Array.from,
            bodyItems = castArray(this.getBodyItems()),
            items = [];

        if (this.includeHeader) {
            items.push(this.getHeader());
        }

        this.items = items.concat([
            {
                xtype: 'simple-container',
                cls: 'sa-prompt-window-body ' + (cls ? (cls + '-body') : ''),
                items: bodyItems
            }
        ]);

        if (this.includeFooter) {
            this.items.push({
                xtype: 'simple-container',
                cls: 'sa-prompt-window-footer ' + (cls ? (cls + '-footer') : ''),
                items: getFooterItems()
            });
        }

        this.callParent();

        function getFooterItems() {
            var items = castArray(me.getFooterItems());

            if (me.includeOkBtn) {
                items.push({
                    xtype: 'sa-button',
                    cls: 'sa-prompt-window-ok-btn',
                    handler: () => Ext.callback(me.okAction, me),
                    text: 'OK',
                    ui: 'primary'
                });
            }

            if (me.includeCancelBtn) {
                items.push({
                    xtype: 'sa-button',
                    handler: () => Ext.callback(me.cancelAction, me),
                    text: 'Cancel'
                });
            }

            return items;
        }
    },

    getFooterHeight() {
        return this.el.down('.sa-prompt-window-footer').getHeight();
    },

    getFooterItems() {
        return [];
    },

    getHeader() {
        return {
            xtype: 'simple-container',
            cls: 'sa-prompt-window-header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-prompt-window-header-title',
                    html: this.getTitle()
                }, {
                    xtype: 'close-button',
                    closeAction: this.closeAction,
                    hidden: !this.includeCloseBtn
                }
            ]
        };
    },

    getHeaderHeight() {
        return this.el.down('.sa-prompt-window-header').getHeight();
    },

    getTitle() {
        return this.title || '';
    }
});
